var _style, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMuyCoachLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MyCoach_Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 334.1 176",
    style: {
      enableBackground: "new 0 0 334.1 176"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{fill:#264484;}\n\t.st2{fill:#EDB955;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 334.1,
    height: 176
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_332",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_898",
    className: "st1",
    d: "M147,92.6v-0.1c0-12.8,10-22.4,22.9-22.4c9.5,0,15.9,4.6,19.5,11.2l-11.9,6.9 c-1.6-3.1-3.9-5.2-7.8-5.2c-4.9,0-8.1,4.2-8.1,9.4v0.1c0,5.6,3.3,9.5,8.1,9.5c4.1,0,6.3-2.2,8.1-5.4l11.9,6.7 c-3.6,6.4-9.6,11.6-20.3,11.6C157.4,114.9,147,105.9,147,92.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_899",
    className: "st1",
    d: "M189.1,97.3v-0.1c0-9.5,7.9-17.6,18.9-17.6c11,0,18.8,8,18.8,17.5v0.1 c0,9.5-7.9,17.6-18.9,17.6C196.9,114.8,189.1,106.8,189.1,97.3 M213.5,97.3v-0.1c0.1-3.2-2.3-5.8-5.5-6c0,0,0,0,0,0 c-3.1,0.1-5.5,2.6-5.4,5.7c0,0,0,0.1,0,0.1v0.1c-0.1,3.2,2.3,5.8,5.5,6c0,0,0,0,0,0c3.1-0.1,5.5-2.6,5.4-5.7 C213.5,97.4,213.5,97.4,213.5,97.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_900",
    className: "st1",
    d: "M227.5,104.4v-0.1c0-6.7,5-10.4,12.8-10.4c2.7,0,5.4,0.4,7.9,1.2v-0.6 c0-3.1-1.9-4.9-6.2-4.9c-3.2,0-6.3,0.7-9.3,1.9l-2.5-9.3c4.5-1.7,9.3-2.5,14.1-2.5c6.8,0,11.2,1.4,14.2,4.4 c2.5,2.5,3.5,5.8,3.5,10.6V114h-14v-3.4c-2.5,2.7-6,4.3-9.6,4.2C232,114.8,227.5,111.1,227.5,104.4 M248.3,101.6v-1.4 c-1-0.4-2.1-0.6-3.2-0.6c-2.8,0-4.3,1.7-4.3,3.7v0.1c-0.1,1.7,1.2,3.2,3,3.3c0.1,0,0.2,0,0.2,0 C246.5,106.7,248.3,104.8,248.3,101.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_901",
    className: "st1",
    d: "M263.7,97.4v-0.1c0-9.4,7.4-17.6,18.3-17.6c7.4,0,12.6,3.8,15.2,9.3l-10,5.7 c-1.2-2.2-2.6-3.4-4.9-3.4c-3,0-5.2,2.6-5.2,5.9v0.1c0,3.5,2.2,6,5,6c2.5,0,3.9-1.2,5.2-3.4l10.1,5.8c-3,5.6-8.1,9.2-16.1,9.2 c-9.6,0.1-17.5-7.6-17.6-17.2C263.7,97.6,263.7,97.5,263.7,97.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_902",
    className: "st1",
    d: "M298.4,69.1h14v15.8c2.4-3.3,6.2-5.2,10.3-5.3c7.1,0,11.5,4.7,11.5,12.2V114h-14V96.3 c0-2.9-1.7-4.5-3.8-4.5s-4,1.7-4,4.5V114h-14V69.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_903",
    className: "st1",
    d: "M0,71.9h15l9.2,15.2l9.2-15.2h15v43.2H34.2V93.7l-9.9,15.4H24l-9.9-15.4v21.4H0V71.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_904",
    className: "st1",
    d: "M50.8,101.6V75.4h16.5v20.9c0,3.4,2,5.4,4.5,5.4s4.7-2,4.7-5.4V75.4H93v39.7H76.5v-5.3 c-2.8,3.9-7.3,6.2-12.2,6.3C56,116,50.8,110.5,50.8,101.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_905",
    className: "st1",
    d: "M95.1,122.8l4.8-11.3c3,1.7,5.7,2.6,7.3,2.6c0.9,0,1.9-0.2,2.7-0.6L94.3,75.4h17.1l6.9,21 l6.3-21h16.8l-13.8,37c-3.9,10.4-8.1,14.6-17.2,14.6C105,126.9,99.8,125.5,95.1,122.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_906",
    className: "st2",
    d: "M138.1,48c-4.9-12.2-12.7-23.1-22.8-31.6C102.8,6,87,0.3,70.7,0C54.4,0.3,38.7,6,26.1,16.4 C16,24.9,8.2,35.7,3.3,48C1.9,51.5,0.8,55.2,0,58.9h16.1c5.3-26,28.1-43.5,54.6-44c26.5,0.5,49.2,18,54.6,44h16.1 C140.6,55.2,139.5,51.5,138.1,48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_907",
    className: "st2",
    d: "M14,147.8l28.8-19.9h24.6L0,176v-48.1h14V147.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuyCoachLogo);
export default __webpack_public_path__ + "static/media/muy-coach-logo.7df139f675e2a484befc9bf319708f5a.svg";
export { ForwardRef as ReactComponent };